var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login-page" }, [
    _vm.forgotPasswordSpinner
      ? _c(
          "div",
          { staticClass: "redirect-overlay" },
          [
            _c("fa", {
              staticClass: "fa-spin mb-2",
              attrs: { icon: ["fas", "spinner"], size: "2x" },
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Redirecting to Login...")]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "brand-panel" }, [
      _c("img", {
        staticClass: "brand-bg-map",
        attrs: {
          src: require("../../assets/roadNetworkMap.svg"),
          alt: "",
          "aria-hidden": "true",
        },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "brand-veil",
        attrs: { "aria-hidden": "true" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "brand-coords" }, [
        _vm._v("42.4240° N · 83.4250° W"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "brand-content" }, [
        _c("p", { staticClass: "brand-tagline" }, [
          _vm._v("Map Management Platform"),
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "brand-features" }, [
          _c("li", [
            _c(
              "span",
              { staticClass: "brand-feature-icon" },
              [_c("fa", { attrs: { icon: ["fas", "layer-group"] } })],
              1
            ),
            _vm._v("\n          HD maps\n        "),
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "span",
              { staticClass: "brand-feature-icon" },
              [_c("fa", { attrs: { icon: ["fas", "globe-americas"] } })],
              1
            ),
            _vm._v("\n          Global Geospatial Data\n        "),
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "span",
              { staticClass: "brand-feature-icon" },
              [_c("fa", { attrs: { icon: ["fas", "eye"] } })],
              1
            ),
            _vm._v("\n          Precision\n        "),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "brand-footer" }, [
        _c(
          "a",
          {
            staticClass: "brand-legal",
            attrs: { href: "https://dmp-maps.com/legal/", target: "_blank" },
          },
          [
            _vm._v(
              "\n        © " +
                _vm._s(new Date().getFullYear()) +
                " Dynamic Map Platform North America, Inc.\n      "
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-panel" }, [
      _c("div", { staticClass: "form-stack" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "form-card" }, [
          _c("div", { staticClass: "form-header" }, [
            _c("h2", { staticClass: "form-title" }, [_vm._v("Reset Password")]),
            _vm._v(" "),
            _c("p", { staticClass: "form-subtitle" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.otpSent
                      ? "Enter the 6-digit code sent to your email."
                      : "Enter your registered email to receive a verification code."
                  ) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.showemailbox
            ? _c("div", { staticClass: "field-group" }, [
                _c("label", { staticClass: "field-label" }, [_vm._v("Email")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-wrap" },
                  [
                    _c("b-form-input", {
                      staticClass: "login-input",
                      attrs: {
                        type: "email",
                        name: "email",
                        placeholder: "you@example.com",
                      },
                      model: {
                        value: _vm.email,
                        callback: function ($$v) {
                          _vm.email = $$v
                        },
                        expression: "email",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "login-btn mt-4",
                    on: {
                      click: function ($event) {
                        return _vm.sendOneTimeVerificationCode()
                      },
                    },
                  },
                  [
                    _vm._v("\n          Send Code\n          "),
                    _c("fa", {
                      staticClass: "ms-2",
                      attrs: { icon: ["fas", "paper-plane"] },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.otpSent
            ? _c("div", { staticClass: "field-group" }, [
                _c("label", { staticClass: "field-label" }, [
                  _vm._v("Verification Code"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "otp-wrap", on: { click: _vm.focusInput } },
                  [
                    _c("b-form-input", {
                      staticClass: "invisible-input",
                      attrs: {
                        type: "number",
                        maxlength: "6",
                        autocomplete: "off",
                        disabled: !_vm.otpSent,
                      },
                      model: {
                        value: _vm.onetimecode,
                        callback: function ($$v) {
                          _vm.onetimecode = $$v
                        },
                        expression: "onetimecode",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "otp-display" },
                      _vm._l(6, function (i) {
                        return _c("span", { key: i, staticClass: "otp-box" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.onetimecode[i - 1] || "") +
                              "\n            "
                          ),
                        ])
                      }),
                      0
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "login-btn mt-1",
                    on: {
                      click: function ($event) {
                        return _vm.verifyOneTimeCode()
                      },
                    },
                  },
                  [
                    _vm._v("\n          Verify Code\n          "),
                    _c("fa", {
                      staticClass: "ms-2",
                      attrs: { icon: ["fas", "check"] },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "back-row" }, [
            _c(
              "span",
              {
                staticClass: "back-link",
                on: {
                  click: function ($event) {
                    return _vm.backToLogin()
                  },
                },
              },
              [
                _c("fa", {
                  staticClass: "me-1",
                  attrs: { icon: ["fas", "arrow-left"] },
                }),
                _vm._v("\n          Back to Login\n        "),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "form-logo-link",
        attrs: { href: "https://www.ushrauto.com/", target: "_blank" },
      },
      [
        _c("img", {
          staticClass: "form-logo",
          attrs: {
            src: require("../../assets/dmpLogin.png"),
            alt: "Dynamic Map Platform",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }